/** @format */
import { convertRemToPixels } from '@toucan/client/global/application';

import { ProductCardBreakpointsState } from './index';

/**
 * These constants should be relocated to their respective components
 * when the sub-components are converted into molecules
 */
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const SKU_CODE_HEIGHT = '1.8rem';
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const THUMBNAIL_CONTAINER_GAP = '0.4rem';
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const IMAGE_CONTAINER_HEIGHT = '20rem';
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const NUM_EXPECTED_ATTRIBUTES = 1;

/**
 * Gets the CSS `height` property for the thumbnail
 *
 * @returns CSS `height` property
 */
export const getThumbnailHeight = () =>
    `${
        convertRemToPixels(IMAGE_CONTAINER_HEIGHT) -
        convertRemToPixels(THUMBNAIL_CONTAINER_GAP) -
        convertRemToPixels(SKU_CODE_HEIGHT)
    }px`;

/**
 * Gets the CSS `gap` property for the details container
 *
 * @param productCardBreakpointsState The state of the product card breakpoints
 *
 * @returns CSS `gap` property
 */
export const getDetailsContainerGap = (
    productCardBreakpoints: ProductCardBreakpointsState
) => {
    return productCardBreakpoints?.medium
        ? 'var(--layout-spacing-48)'
        : 'var(--layout-spacing-8)';
};

/**
 * Gets the CSS `margin-top` property for the details container
 *
 * Calculates how much marginTop is needed to center the details container
 * This allows that the details container to grow and shrink
 * without shifting it's offset from the top of the component
 *
 * @param productCardBreakpointsState The state of the product card breakpoints
 * @param highlightsContainerHeight The height of the highlights container
 * @param boxListHeaderHeight The height of the box list header
 *
 * @returns CSS `margin-top` property
 */
export const getDetailsContainerMarginTop = (
    productCardBreakpointsState: ProductCardBreakpointsState,
    highlightsContainerHeight: number,
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types -- Legacy code: do not use as an example.
    boxListHeaderHeight: number = 0
) => {
    const detailsContainerGap = convertRemToPixels(
        getDetailsContainerGap(productCardBreakpointsState)
    );

    const detailsContainerHeight =
        highlightsContainerHeight + boxListHeaderHeight + detailsContainerGap;

    const imageContainerHeight = convertRemToPixels(IMAGE_CONTAINER_HEIGHT);

    const heightDifference = Math.max(
        0,
        imageContainerHeight - detailsContainerHeight
    );

    const marginTop = heightDifference / 2;

    return `${marginTop}px`;
};
